import React from 'react';
import CatalogManager from '../components/CatalogManager';

export default function Categories() {
  return (
    <div className="space-y-6" data-testid="categories-page">
      <CatalogManager standalone singleTab defaultTab="categories" />
    </div>
  );
}
